import '../../styles/_credit-progress-saved.scss';

import React from 'react';

import creditProgressMessagesDefaults from '../../datasource/defaults/creditProgressMessages.json';
import { useGetCreditProgressMessagesQuery } from '../../datasource/queries/cmsMessages';

interface CreditProgressSavedProps {
    savedAt?: Date;
}

const creditProgressSavedTimeFormatter = new Intl.DateTimeFormat(undefined, {
    hour: 'numeric',
    minute: '2-digit'
});

export const formatCreditProgressSavedTime = (savedAt: Date) => creditProgressSavedTimeFormatter.format(savedAt);

export const CreditProgressSaved = ({ savedAt }: CreditProgressSavedProps) => {

    const { data } = useGetCreditProgressMessagesQuery();
    const fallbackSavedAt = React.useRef(savedAt ?? new Date());
    const displayedSavedAt = savedAt ?? fallbackSavedAt.current;
    
    const text = data?.creditProgressSavedMessage ?? creditProgressMessagesDefaults.creditProgressSavedMessage;

    return <span className='credit-progress-saved' role='status'>
        <span>{text}{' '}</span>
        <time
            className='credit-progress-saved__timestamp'
            dateTime={displayedSavedAt.toISOString()}>
            {formatCreditProgressSavedTime(displayedSavedAt)}
        </time>
    </span>;
};

export default CreditProgressSaved;
